var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yanyana-container",on:{"click":_vm.handlerYanYana}},[_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.$t("seatMapModal_lblYanyana"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }